import AbstractComponent from './abstract-component.js';

const createTemplate = (className, source, title, width, height, isShow) => {
  return (
    `<img class="${className} ${isShow ? `` : `visuallyhidden`}" 
      src="${source}" 
      alt="${title}" 
      ${width ? `width="${width}"` : ``}
      ${height ? `height="${height}"` : ``}
    >`
  );
};

export default class ImgComponent extends AbstractComponent {
  constructor({className = ``, source, title = ``, width, height, isShow = true}) {
    super();

    this._className = className;
    this._source = source;
    this._title = title;
    this._width = width;
    this._height = height;
    this._isShow = isShow;

    // this._onLoadHandler();
    // this._onErrorHandler();
  }

  getTemplate() {
    return createTemplate(this._className, this._source, this._title, this._width, this._height, this._isShow);
  }

  // get isShow() {
  //   return this._isShow;
  // }

  // set isShow(data) {
  //   this._isShow = data;
  //   this.getElement().classList.remove(`visuallyhidden`);
  // }

  // setClickHandler(handler) {
  //   this.getElement().addEventListener(`click`, () => handler(this._source));
  // }

  // setImgLoadHandler(handler) {
  //   this.getElement().addEventListener(`load`, () => handler(this));
  // }

  // setImgErrorHandler(handler) {
  //   this.getElement().addEventListener(`error`, () => handler(this));
  // }

  // _onLoadHandler() {
  //   this.getElement().addEventListener(`load`, () => {
  //     this.isShow = true;
  //   });
  // }

  // _onErrorHandler() {
  //   this.getElement().addEventListener(`load`, () => {
  //     this.isShow = false;
  //   });
  // }
}
